import { JSX } from "react";
import { useCompany } from "@/features/company/hooks/use-company";
import { companyDetails } from "@/features/company/types";
import { formStyle } from "../form-style";
import { ProVerifiedDocumentType } from "./verified-company-form-document-type";
import { ProVerifiedDocumentUpload } from "./verified-company-form-document-upload";

type VerifiedCompanyFormProps = {
  companyDetails: companyDetails;
  tooltipContent: string;
  isAdmin: boolean;
  actionEnabled?: boolean;
};

export const VerifiedCompanyForm = ({
  companyDetails,
  tooltipContent,
  isAdmin = false,
  actionEnabled
}: VerifiedCompanyFormProps): JSX.Element => {
  // Upload document useQuery (also trigger company fetch by disabling cache)
  const { partialEditCompanyMutation } = useCompany();
  const { mutateAsync: partialEditCompanyData } = partialEditCompanyMutation();

  return (
    <div className={formStyle.container}>
      <ProVerifiedDocumentType
        companyDetails={companyDetails}
        uploadDocumentData={partialEditCompanyData}
        isAdmin={isAdmin}
        actionEnabled={actionEnabled}
      />
      <ProVerifiedDocumentUpload
        companyDetails={companyDetails}
        isAdmin={isAdmin}
        uploadDocumentData={partialEditCompanyData}
        tooltipContent={tooltipContent}
        actionEnabled={actionEnabled}
      />
    </div>
  );
};
